import { render } from "./user_checkboxes.vue?vue&type=template&id=1afbd86b&lang=pug"
import script from "./user_checkboxes.vue?vue&type=script&lang=js"
export * from "./user_checkboxes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__